/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Preroll = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Preroll"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#000"
        fillOpacity={0.5}
        fillRule="evenodd"
        d="M21.044 2.446a.843.843 0 0 0-1.156-.338c-.708.399-1.274 1.048-1.288 1.919-.014.836.49 1.557 1.172 2.107.481.387.529.651.528.722 0 .036-.018.215-.412.437a.87.87 0 0 0-.332 1.174.843.843 0 0 0 1.156.337c.708-.398 1.273-1.047 1.288-1.918.014-.836-.49-1.558-1.172-2.107-.482-.387-.53-.652-.528-.723 0-.035.017-.214.412-.436a.87.87 0 0 0 .332-1.174"
        className="Details"
        clipRule="evenodd"
      />
      <path
        fill="#F50"
        fillRule="evenodd"
        d="M17.23 7.551c.566.654 1.21 1.59 1.817 2.658.606 1.067 1.082 2.104 1.356 2.927.135.405.236.802.264 1.146a1.8 1.8 0 0 1-.038.583c-.053.21-.186.51-.504.698q-.07.04-.145.07l-14.01 6.24c-.408.21-.818.12-1.074.015a2.7 2.7 0 0 1-.756-.5c-.45-.404-.905-.997-1.29-1.675s-.662-1.375-.782-1.972a2.8 2.8 0 0 1-.048-.916c.04-.277.167-.684.55-.936l12.322-9.214q.061-.05.132-.092c.319-.187.641-.153.846-.095.203.058.38.162.517.259.278.196.566.483.844.804"
        className="Main"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillOpacity={0.5}
        d="M13.354 10.556a.87.87 0 0 1-.31 1.18.843.843 0 0 1-1.162-.316.87.87 0 0 1 .311-1.18.843.843 0 0 1 1.161.316m3.484.949a.87.87 0 0 1-.31 1.18.843.843 0 0 1-1.162-.316.87.87 0 0 1 .311-1.18.843.843 0 0 1 1.161.316m-1.244 4.721a.87.87 0 0 0 .31-1.18.843.843 0 0 0-1.16-.317.87.87 0 0 0-.312 1.18.843.843 0 0 0 1.162.317m-3.173-2.129a.87.87 0 0 1-.311 1.18.843.843 0 0 1-1.161-.316.87.87 0 0 1 .31-1.18.843.843 0 0 1 1.162.316M6.22 18.733a.87.87 0 0 0 .311-1.18.843.843 0 0 0-1.161-.316.87.87 0 0 0-.311 1.18.843.843 0 0 0 1.161.316m2.406-4.405a.87.87 0 0 1-.311 1.18.843.843 0 0 1-1.161-.315.87.87 0 0 1 .31-1.18.843.843 0 0 1 1.162.315m1.389 4.174a.87.87 0 0 0 .311-1.18.843.843 0 0 0-1.161-.317.87.87 0 0 0-.311 1.18.843.843 0 0 0 1.161.317"
        className="Details"
      />
    </g>
  </svg>
);

export const PrerollIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'preroll-icon'}
      icon={Preroll}
      {...props}
      size={size}
    />
  );
};
